import { PropsWithChildren, ReactNode } from 'react';

import { mergeSx, SxProps, Box, Stack } from '@cast/design-system';

export type OverlayWithBlurProps = PropsWithChildren<{
  active: boolean;
  content?: ReactNode;
  testId?: string;
  position?: {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
  };
  containerSx?: SxProps;
  blurContainerSx?: SxProps;
  blurZIndex?: number;
}>;

export const OverlayWithBlur = ({
  active,
  content,
  children,
  testId = 'blur-overlay',
  position = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  containerSx,
  blurContainerSx,
  blurZIndex = 1,
}: OverlayWithBlurProps) => {
  return (
    <Stack sx={containerSx} data-testid={testId}>
      {content}
      <Box
        sx={mergeSx(
          { position: 'relative', userSelect: 'none' },
          blurContainerSx
        )}
      >
        {children}
        <Box
          sx={{
            position: 'absolute',
            top: `${(position.top ?? 0) - 4}px`,
            bottom: `${(position.bottom ?? 0) - 4}px`,
            left: `${(position.left ?? 0) - 4}px`,
            right: `${(position.right ?? 0) - 4}px`,
            transition: 'backdrop-filter 0.5s',
            backdropFilter: active ? 'blur(4px)' : 'blur(0px)',
            pointerEvents: active ? undefined : 'none',
            zIndex: active ? blurZIndex : -1,
          }}
        />
      </Box>
    </Stack>
  );
};
